var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1282_24844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55425 25.6667H28.1098C28.782 25.6667 29.332 25.1167 29.332 24.4444C29.332 23.7722 28.782 23.2222 28.1098 23.2222H8.55425C7.88203 23.2222 7.33203 23.7722 7.33203 24.4444C7.33203 25.1167 7.88203 25.6667 8.55425 25.6667ZM8.55425 19.5556H28.1098C28.782 19.5556 29.332 19.0056 29.332 18.3333C29.332 17.6611 28.782 17.1111 28.1098 17.1111H8.55425C7.88203 17.1111 7.33203 17.6611 7.33203 18.3333C7.33203 19.0056 7.88203 19.5556 8.55425 19.5556ZM7.33203 12.2222C7.33203 12.8944 7.88203 13.4444 8.55425 13.4444H28.1098C28.782 13.4444 29.332 12.8944 29.332 12.2222C29.332 11.55 28.782 11 28.1098 11H8.55425C7.88203 11 7.33203 11.55 7.33203 12.2222Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1282_24844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.6667,
    height: 36.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.feb9befa23f1e7e9defcbf61cfbe9808.svg";
export { ForwardRef as ReactComponent };